import {useAppSelector} from 'hooks'

import {useAppDispatch} from 'store'

import {ILicenseItem} from 'api/productApi'
import {
  handleGetListLicenseLogs,
  handleGetListLicenseWithItem,
  selectedLicenseData,
  selectError,
  selectListActive,
  selectListDiscontinue,
  selectListLicenseLogs,
  selectListLicenseWithItem,
  selectLoading,
  setSelectLicense,
} from './productUsageHistorySlice'

export default function useProductUsageHistory() {
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoading)
  const error = useAppSelector(selectError)
  const selectedId = useAppSelector(selectedLicenseData)
  const listLicenseWithItem = useAppSelector(selectListLicenseWithItem)
  const listLicenseLogs = useAppSelector(selectListLicenseLogs)
  const listActive = useAppSelector(selectListActive)
  const listDiscontinue = useAppSelector(selectListDiscontinue)

  const onSearchLicenseLogs = (payload: ILicenseItem) => {
    try {
      dispatch(handleGetListLicenseLogs(payload.licenseId))
      dispatch(setSelectLicense(payload))
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
  }

  const onSearchLicenseLogsWithId = (licenseId: string) => {
    try {
      dispatch(handleGetListLicenseLogs(licenseId))
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
  }
  const fetchLicenseWithItem = () => {
    try {
      dispatch(handleGetListLicenseWithItem())
    } catch (e) {
      console.error('fetchLicense failed', e)
    }
  }

  return {
    loading,
    error,
    fetchLicenseWithItem,
    onSearchLicenseLogs,
    onSearchLicenseLogsWithId,
    selectedId,
    listLicenseWithItem,
    listLicenseLogs,
    listActive,
    listDiscontinue,
  }
}
